module.exports = __webpack_public_path__ + "img/group2.57c590c2.svg";